"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpineAsset = void 0;
var Utils_1 = require("../../Utils");
var AssetMapData_1 = require("../AssetMapData");
var SpineAsset = /** @class */ (function (_super) {
    __extends(SpineAsset, _super);
    function SpineAsset(assetName, assetPathOrType, atlasPathOrName) {
        var _this = _super.call(this, assetName, typeof assetPathOrType === "number" ? assetPathOrType : Utils_1.AssetType.SPINE_JSON) || this;
        if (typeof assetPathOrType === "string") {
            _this.assetPath = assetPathOrType;
        }
        _this.atlasPath = atlasPathOrName;
        return _this;
    }
    SpineAsset.prototype.getAsset = function () {
        return this.getResource().spineData;
    };
    SpineAsset.prototype.getLoaderOptions = function () {
        if (this.atlasPath) {
            var atlasPath = this.atlasPath.indexOf("/") >= 0
                ? Utils_1.AssetUtils.replaceResolutionToken(this.atlasPath)
                : Utils_1.AssetUtils.getPathToAsset(this.atlasPath, Utils_1.AssetType.SPINE_ATLAS);
            return {
                metadata: {
                    imageNamePrefix: "spineAtlas_",
                    spineAtlasFile: atlasPath,
                },
            };
        }
        return undefined;
    };
    return SpineAsset;
}(AssetMapData_1.AssetMapData));
exports.SpineAsset = SpineAsset;
//# sourceMappingURL=SpineAsset.js.map